<template>
  <div class="addcourse addcourseware coursewareModle commonAddcourse manageMeeting">
    <!--面包屑-->
    <div class="crumbs">
      <span><router-link :to="{name:'EntryPage'}">首页</router-link></span> >
      <span><router-link :to="{name:'ManageMeeting'}">专题读片</router-link></span> >
      <span>详情</span>
    </div>
    <!--搜索框-->
    <!--视频-->
    <div id="mp4" class="mp4-area" v-show="mp4Show">
      <div id="coor"></div>
      <div class="mp4-head">
        <span>{{lessonName}}</span>
        <i id="close-mp4" @click="closeMp4" class="iconfont icon-yichu"></i>
      </div>
      <div class="mp4-left">
        <ul>
          <li :class="{'play-now': playIndex == index}" @click="playVideo(video, index)" v-for="(video, index) in lessonInfo.videoList" :key="index"><b>{{video.fileName}}</b><span></span></li>
        </ul>
      </div>
      <div class="mp4-video">
     <video id="videoElement" ref="video" v-if="videoShow" controls autoplay>
          <source :src="videoSrc" type="video/ogg">
          <source :src="videoSrc" type="video/mp4">
          <object data="movie.mp4" width="320" height="240">
            <embed width="320" height="240" src="movie.swf">
          </object>
        </video>
  <!--      <iframe :src="videoSrc"    ref="video"  id="videoElement"  class="iframe-video" v-if="videoShow"  width="100%" height="100%"  border="0"  frameborder="0"></iframe> -->
      </div>
      <!-- <iframe src="https://www.baidu.com" width="90%" height="90%" frameborder="0"></iframe> -->
    </div>
    <div class="querysearch course_query left-area" id="drag-left">
      <!-- drag -->
      <div id="drag" @mousedown="drag" @mouseup="dragup">
        <!-- drag -->
      </div>
      <div class="course_top">
        <el-row>
          <el-col :span="9">
            <span class="manageTitle">{{this.detailList.confName}}</span>
            <span class="managesm">{{this.detailList.openFlag}}</span>
          </el-col>
          <el-col :span="5" style="float:right;">
            <!--<el-button @click="inputOrplaybackFun" v-show="enterCon" class="playback" :class="{'playback':isA,'unplayback':!isA}" >{{ inputOrplayback }}</el-button>-->
            <div @click="inputOrplaybackFun" v-show="enterCon" class="playback" :class="{'playback':isA,'unplayback':!isA}" >{{ inputOrplayback }}</div>
          </el-col>
        </el-row>
        <el-row style="padding-top: 15px;">
          <el-col :span="6">
            <span class="label_title">主持人：</span>
            <span class="info_content">{{this.detailList.confChairName}}</span>
          </el-col>
          <el-col :span="8">
            <span class="label_title">会议时间：</span>
            <span class="info_content">{{this.detailList.confTime}}</span>
          </el-col>
          <el-col :span="10">
            <span class="label_title">会议地址：</span>
            <span class="info_content">{{this.detailList.confAddress}}</span>
          </el-col>
        </el-row>
        <el-row class="remarkTxt">
          <el-col :span="24">
            <span class="label_title" >参会人员：</span>
            <div class="info_content dif_cont">
             <span v-for="item of attendL" >
                <b>{{item.name}}</b>
                <em v-show="item.attendEm">{{item.job}}</em>，
            </span></div>
          </el-col>
          <el-col :span="24" v-show="memberCountShow">
            <el-dropdown class="members fr">
          <span class="el-dropdown-link">
           <el-badge :value="memberCount" class="item" :max="99">
             实际到会
            </el-badge>
            <i class="el-icon-arrow-down el-icon--right item"></i>
          </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item,index) in attendList" disabled  :key="index">{{ item.docName }} </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--切换-->
    <div class="tabs-content">
<!--       <div class="addCourse">
        <div v-show="addBtn" class="addBtn" >{{text}}</div>
      </div> -->
      <div class="tabs-text">
        <el-tabs v-model="activeName1" @tab-click="handleClick">
         <el-tab-pane name="first">
            <span slot="label">其他附件({{attachList.length}})</span>
            <div class="file-block"  ref="files" >
            <uploadDetail :updateFileList="updateFileList" :updatePicList="updatePicList"></uploadDetail>
            </div>
          </el-tab-pane>
          <el-tab-pane name="second" class="p-table-text">
                <span slot="label">相关影像({{studyList.length}})</span>
            <p-table :operationWidth="operationWidth" :head="head" :data="data" :operation="operation" @_operation="_operation_" :autoheight="autoheight"></p-table>
          </el-tab-pane>
          <el-tab-pane  name="third" class="p-table-text">
             <span slot="label">相关病例({{caseList.length}})</span>
            <p-table :head="headVal" :data="dataVal" :operation="operation2" @_operation="_operation2_" :autoheight="autoheight"></p-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--病例详情弹框-->
    <pops :show="popDetail" :title="'病例详情'" @closePop="closePopDetail" :width="'60%'">
      <div class="popScore carsePop">
        <div class="popContent detailCont popTxt">
          <el-row class="row">
            <el-col :span="12">
              <div>
                <span class="label">病例名称：</span>
                <span class="content">{{this.medicDetail.caseName}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="label">病例分类：</span>
                <span class="content">{{typeName}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="12">
              <div style="margin-left:12px">
                <span class="label">性别：</span>
                <span class="content">{{this.medicDetail.caseSex}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div style="margin-left:12px">
                <span class="label">年龄：</span>
                <span class="content">{{this.medicDetail.caseAge}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="12">
              <div>
                <span class="label">检查类型：</span>
                <span class="content">{{this.medicDetail.examTypeName}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="label">检查项目：</span>
                <span class="content">{{this.medicDetail.examBodyName}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="row changeHeight">
            <el-col :span="24">
              <div>
                <span class="label">患者病史：</span>
                <span class="content disContent">{{this.medicDetail.history}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="row changeHeight">
            <el-col :span="24">
              <div>
                <span class="label">影像所见：</span>
                <span class="content disContent">{{this.medicDetail.evidence}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="row changeHeight">
            <el-col :span="24">
              <div>
                <span class="label">诊断结果：</span>
                <span class="content disContent">{{this.medicDetail.dianogeResult}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="row changeHeight">
            <el-col :span="24">
              <div>
                <span class="label">病理结果：</span>
                <span class="content disContent">{{this.medicDetail.caseResult}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--确定取消按钮-->
        <div class="btn-box">
          <el-button @click="_savePopDetail" class="save">确定</el-button>
          <el-button @click="_cancel" class="cancel">取消</el-button>
        </div>
      </div>
    </pops>
    <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
  </div>
</template>

<script type="text/ecmascript-6">
  import btns from '@/components/common/button/buttons'
  import pops from '@/components/common/pops/pop'
  import tabs from '@/components/common/tabs/tabs'
  import radiusInput from '@/components/common/radiusInput/radiusInput'
  import pTable from '@/components/common/tables/publicTable'
  import alonebutton from '@/components/common/button/aloneButton'
  import uploadDetail from "@/components/common/upload/uploadDetail"
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
  import {nomalTime} from '@/common/js/time'
  import {getLocalStorage, saveLocalStorage, clearLocalStorage} from '@/common/js/localStorage'
  import {changehosArea,changeAge,changeGender,changeSex,changeclinicType} from '@/common/js/change'

  import aycanImages from '@/components/common/base/aycanImages'
  export default {
    components: {
      tabs,
      radiusInput,
      pTable,
      alonebutton,
      btns,
      pops,
      uploadDetail,
      aycanImages
    },
    data() {
      return {
        page: {
          total: 0,
          currentPage: 0,
          pageSize: 10
        },
        confId: '', //会议id
        ConfPassword: '', //会议密码
        popDetail: false,
        medicDetail:'',
        conTime:'',
        typeName: '',
        attachList:0,  //其他附件的数量
        caseList:0, //相关病例的数量
        studyList:0, //相关影像的数量
        activeName1: 'first',
        activeName: '1',
        updateFileList: [],
        updatePicList: [],
        operationWidth: '100px',
        memberCountShow: false, //实际到会是否显示
        inputOrplayback: '', //回放录播or进入会议
        isA: false, //颜色是否置灰
        ManageStatus: '', //会议状态
        ManagesendState: '',//发送状态
        ManaStartDateStr: '',//会议开始时间
        enterCon: true, //进入会议按钮是否显示
        videoList: [], //回访内容
        sendList: '',//参会人员
        attendL:[],
        sendListlitte: '',//参会人员省略显示
        detailList:{}, //详情头部数据
        memberCount: '',//实际到会人数
        attendList:[],//实际到会人员
        confChairName: '', //登录信息名
        confChairNameStr: '',//主持人
        mp4Show:false,
        videoShow:false,
        lessonName: '回放录播',
        playIndex: 0,
        closeBtnBool:true,
        lessonInfo:{}, //会议
        videoSrc: '',  //播放的src地址
        bIsResizing: false,
        autoheight:this.getH(),
        head: [
          {
            props: 'hospitalName',
            label: '来源',
            width: '10%'
          }, {
            props: 'patientId',
            label: '患者编号',
            width: '10%'
          },{
            props: 'accessionNumber',
            label: '检查号',
            width: '12%'
          }, {
            props: 'patientName',
            label: '患者姓名',
            width: '8%'
          }, {
            props: 'examTypeName',
            label: '检查类型',
            width: '12%'
          }, {
            props: 'examBodyName',
            label: '检查项目',
            width: '12%'
          }, {
            props: 'examDate',
            label: '检查时间',
            width: '18%'
          }
        ],
        headVal:
          [
            {
              props: "caseName",
              label: "病例名称"
            },
            {
              props: "privateType",
              label: "访问权限"
            },
            {
              props: "caseSex",
              label: "性别"
            },
            {
              props: "caseAge",
              label: "年龄"
            },
            {
              props: "createDateStr",
              label: "创建时间"
            },
            {
              props: "creatorName",
              label: "创建人"
            }
          ],
        data: [],
        dataVal: [],
        operation: [
          {
            name: '阅片',
            operation: '',
            class: 'icon-yuepian'
          }
        ],
        operation2: [
          {
            name: '查看',
            operation: '',
            class: 'icon-chakan'
          }
        ],
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        }
      }
    },
    mounted() {
      //this.$refs.files.style.height = this.autoheight + 'px'
      window.addEventListener('resize', () => {
        setTimeout(() => {
          //this.$refs.files.style.height = this.autoheight + 'px'
          this.getH()
        }, 50)
      })
      //登录用户信息
      http.post('/getUserInfo.json').then(res => {
        if (res.data.code === _.ERR_OK) {
          this.confChairName = res.data.model.userName
          this.conTime = new Date(res.data.model.doctorSign).getTime()
        }
      }).catch(() => {

      })
    },
    methods: {
      getH(){
        this.autoheight = document.body.clientHeight - 50 - 40 - 105 - 15 - 75 - 15
        //header + crumb + search + padding + tab + marinbottom
      },
      closePopDetail(payload) { //关闭病例详情弹窗
        this.popDetail = payload
      },
      _savePopDetail() { //病例详情弹窗确定
        this.popDetail = false
      },
      _cancel() { //病例详情弹窗取消
        this.popDetail = false
      },
      inputOrplaybackFun() {

        if(this.ManageStatus == '1' && this.isA) {

           //if (this.lessonInfo.videoList.length > 0 ) {
            this.mp4Show = true
            this.videoSrc = this.lessonInfo.videoList[0].uri
           /*  this.videoSrc= this.lessonInfo.videoList[0].playurl */
            this.videoShow = true
          // }
        } else if(this.ManageStatus == '0' && this.ManagesendState == '1') {
          let params = {
            id: this.confId,
            confPwd: this.ConfPassword
          }
          let startDatetime = this.ManaStartDateStr.replace("-","/");//替换字符，变成标准格式
          let d2 = new Date(); //取今天的日期
          let  d1 = new Date(Date.parse(startDatetime)); //取会议开始的日期
          let  hosSecond=d1.getTime()-this.conTime  //时间差的毫秒数

          if(hosSecond >= '1800000') {
            if(this.confChairNameStr != this.confChairName) {
              message('会议不满足进入条件或者用户无权限开始会议', false)
            } else {
              message('最多只能提前半小时进入会议', false)
            }
          } else if(hosSecond < '1800000' && this.confChairNameStr == this.confChairName && hosSecond >= '0') {
            this.$confirm('还未到会议时间，是否要提前开始会议', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              http.post('/conference/enterTopicConf.json', params).then(res => {
                if (res.data.code === _.ERR_OK) {
                  this.$router.push({name: 'EnterManageMeeting'})
                  this.popShow = true
                } else {
                  message(res.data.msg, false)
                }
              }).catch(err => {
                errMsg(err)
              })
            })
          } else if(hosSecond < '1800000' && this.confChairNameStr != this.confChairName && hosSecond >= '0') {
            message('会议不满足进入条件或者用户无权限开始会议', false)
          } else {
            http.post('/conference/enterTopicConf.json', params).then(res => {
              if (res.data.code === _.ERR_OK) {
                this.$router.push({name: 'EnterManageMeeting'})
                this.popShow = true
              } else {
                message(res.data.msg, false)
              }
            }).catch(err => {
              errMsg(err)
            })
          }
        } else if(this.ManageStatus == '3' && this.ManagesendState == '1'){
             http.post('/getUserInfo.json').then(res => {
                if (res.data.code === _.ERR_OK) {
                  this.confChairName = res.data.model.userName
                  this.conTime = new Date(res.data.model.doctorSign).getTime()
                }
              }).catch(() => {

              })
           let params = {
            id: this.confId,
            confPwd: this.ConfPassword
          }

          http.post('/conference/enterTopicConf.json', params).then(res => {
              if (res.data.code === _.ERR_OK) {
                this.$router.push({name: 'EnterManageMeeting'})
                this.popShow = true
              } else {
                message(res.data.msg, false)
              }
            }).catch(err => {
              errMsg(err)
            })
          this.$router.push({path: '/Homepage/ManageMeeting/EnterManageMeeting'})
        }
      },
      _operation_(payload) {
         if (payload.operation === 'icon-yuepian') {

          this.params_image.hospitalId = this.data[payload.index].hospitalId;
          this.params_image.studyPk = this.data[payload.index].studyPk+"";
          this.params_image.studyUid = this.data[payload.index].studyUid;
          this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })

          // let Aycan = {

          //   hospitalId:this.data[payload.index].hospitalId,
          //   studyPk:this.data[payload.index].studyPk,
          //   studyUid:this.data[payload.index].studyUid,
          // }
          // http.post('/edu/prepareAycan.json', Aycan).then(res => {
          //   if (res.data.code == "0000") {
          //     window.open(res.data.model,'_blank');
          //   }else{
          //     message('该病人无初始影像',false);
          //   }
          // }).catch(() => {
          // })
         }
      },
      _operation2_(payload) {
          this.popDetail = true
          let params = {
            id: payload.id
          }
          http.post('/caselib/getCaseDetail.json', params).then(res => {
            if (res.data.code === _.ERR_OK) {
              this.medicDetail = res.data.model
              if(this.medicDetail.caseSex === '1'){
                this.medicDetail.caseSex = '男'
              } else if(this.medicDetail.caseSex === '0'){
                this.medicDetail.caseSex = '女'
              }
              if(this.medicDetail.caseAge!==undefined){
                if (this.medicDetail.ageUnit === '4') {
                  this.medicDetail.caseAge = this.medicDetail.caseAge + '岁'
                } else if (this.medicDetail.ageUnit === '3') {
                  this.medicDetail.caseAge = this.medicDetail.caseAge + '月'
                } else if (this.medicDetail.ageUnit === '2') {
                  this.medicDetail.caseAge = this.medicDetail.caseAge + '周'
                } else if(this.medicDetail.ageUnit === '1'){
                  this.medicDetail.caseAge = this.medicDetail.caseAge + '天'
                } else if(this.medicDetail.ageUnit === '5'){
                  this.medicDetail.caseAge = this.medicDetail.caseAge + '小时'
                }
              } else {
                this.medicDetail.caseAge = ''
              }
              let examinePart = "";
              for (let item of this.medicDetail.catalogList) {
                examinePart +="," + item.catalogname;
                if (examinePart.substr(0,1)==',')
                  examinePart=examinePart.substr(1);
              }
              this.typeName = examinePart
            }
          })
      },
      closeMp4() {  //播放器关闭
        this.mp4Show = false
        this.videoShow = false
      },
      playVideo(vedio, index) {
       this.videoSrc = vedio.uri
       /*  this.videoSrc = vedio.playurl */
        this.playIndex = index
        this.$refs.video.src= vedio.playurl
        this.videoShow = true
       // let el = document.getElementById('videoElement')
       // el.play()
        //this.playIndex = index
      },
      dragup() {
        this.bIsResizing = false
      },
      drag() {
        this.bIsResizing = true
        let nLastDownX = event.clientX
        let oLeft = document.getElementById('drag-left'),
          nLeftWidth = oLeft.clientWidth,
          // oRight = document.getElementById('drag-right'),
          nRightWidth = oRight.clientWidth,
          nWidth = document.body.clientWidth
        if (this.bIsResizing) {
          let that = this;
          // 拖拽
          document.onmousemove = function() {
            if (!that.bIsResizing) return false
            var nNewWidth = nLeftWidth - (nLastDownX - event.clientX)
            if (nNewWidth > (nWidth / 2)) {
              nNewWidth = (nWidth / 2) - 4
              that.bIsResizing = false
              return false
            } else if (nNewWidth < 250) {
              nNewWidth = 252
              that.bIsResizing = false
              return false
            }
            //oLeft.style.width = nNewWidth + 'px'
            //oRight.style.width = nWidth - nNewWidth + 'px'
          }
        } else {
          return false
        }
        document.onmouseup = function() {
          let that = this
          that.bIsResizing = false
        }
      },
      getTopicConfDetail(){
        this.confId = getLocalStorage('idVal')
        this.ConfPassword = getLocalStorage('ConfPasswordVal')
        let params = {
          id: this.confId,
          confPwd: this.ConfPassword
        }
        //初始化数据
        this.sendList = ''
        this.attendL=[];
        this.updateFileList= [];
        this.updatePicList= [];
        http.post('/conference/getTopicConfDetail.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            if(res.data.model.status == '1' && res.data.model.sendState == '1') {
              this.memberCountShow = true
            }
            this.detailList.confName = res.data.model.confName
            this.detailList.confChairName = res.data.model.confChairName
            this.detailList.confTime = res.data.model.startDateStr+'-'+res.data.model.endDateStr.slice(res.data.model.endDateStr.indexOf(' ')+1 , res.data.model.endDateStr.length)
            this.detailList.confAddress = res.data.model.confAddress
            if(res.data.model.openFlag == '1') {
              this.detailList.openFlag = '公开'
            } else {
              this.detailList.openFlag = '私密'
            }
            // var examinePart = "";   //开放范围修改部分
            // let attendL = []
            let par = {}
            for (let item of res.data.model.attendList) {
              if(item.attendType == '3'){
                par = {
                  id: item.groupId,
                  name: item.groupName,
                  job: '',
                  attebdType: item.attendType
                }
              }else if(item.attendType =='2'){
                par = {
                  id: item.hosId,
                  name: item.hosName,
                  job: '',
                  attebdType: item.attendType
                }
              }else if(item.attendType =='1'){
                par = {
                  id: item.deptId,
                  name: item.deptName,
                  job: item.hosName,
                  attebdType: item.attendType
                }
              }else{
                par = {
                  id: item.userId,
                  name: item.userName,
                  job: '',
                  // job: item.docTitle,
                  attebdType: item.attendType
                }
              }
              this.attendL.push(par)
              this.attendL.forEach(arr =>{
               if(arr.job == ''){
                  arr.attendEm = false
               }else{
                  arr.attendEm = true
               }
              })

            }

            if(this.sendList.length > 115) {
              this.sendListlitte = this.sendList.slice(0,115)
              this.sendListlitte = this.sendListlitte + '...'
            } else {
              this.sendListlitte = this.sendList
            }
            this.memberCount = res.data.model.attendMemberList.length
            this.attendList = res.data.model.attendMemberList
            this.data = res.data.model.studyList
            for(let item of this.data) {
              item.examDate = nomalTime(item.examDate)
              item.hosArea = changehosArea(item.hosArea)
            }
            for (let item of res.data.model.caseList) {
              if(item.caseSex === '1') {
                item.caseSex = '男'
              } else {
                item.caseSex = '女'
              }
              if(item.privateType === 0) {
                item.privateType = "公共"
              } else if(item.privateType === 1) {
                item.privateType = "个人"
              } else if(item.privateType === 2) {
                item.privateType = "部门公开"
              } else if(item.privateType === 3) {
                item.privateType = "医院公开"
              }
              if(item.caseAge!==undefined){
                item.caseAge = item.caseAge + changeAge(item.ageUnit)
              } else {
                item.caseAge = ''
              }
            }
            this.dataVal = res.data.model.caseList
            this.attachList=res.data.model.attachList
            this.caseList=res.data.model.caseList
            this.studyList=res.data.model.studyList

              //附件
            if (res.data.model.attachList.length > 0) {
              for (let item of res.data.model.attachList) {
                if (item.attach_type === 'file') {
                  this.updateFileList.push(item)
                } else {
                  this.updatePicList.push(item)
                }
              }
            }

            //会议结束
            this.ManageStatus = res.data.model.status
            this.videoList =res.data.model.videoList?res.data.model.videoList.uri:[]
            this.ManagesendState =  res.data.model.sendState
            this.ManaStartDateStr =  res.data.model.startDateStr
            this.confChairNameStr = res.data.model.confChairName  //主持人

            if(res.data.model.status == '1' && res.data.model.sendState == '1') {
              this.enterCon = true
              this.inputOrplayback = '回放录播'
              if(res.data.model.videoList.length > 0) {
                this.isA = true
                this.lessonInfo.videoList = res.data.model.videoList
                this.videoSrc = ''
                //   for (let item of res.data.model.vedioList) {
                //     item.uri // 文件下载路径
                //   }
              } else {
                this.isA = false
              }
            } else if (res.data.model.status == '3' && res.data.model.sendState == '1') {
              this.enterCon = true
              this.inputOrplayback = '进入会议'
              this.isA = true
            } else if (res.data.model.status == '0' && res.data.model.sendState == '1') {
              this.enterCon = true
              this.inputOrplayback = '进入会议'
              this.isA = true
            } else {
              this.enterCon = false
            }

            //回放录播
            // if (res.data.model.vedioList.length > 0) {

            // }




          }
        })
      },
      handleClick(tab, event) { //切换
      },
    },
    created() {
        this.getH();
        this.getTopicConfDetail();
        const that = this;
        this.$events.$on("toQueryManageMeeting",()=>{
           that.getTopicConfDetail();
          }
        );
    },
    beforeDestroy(){
      this.$events.$off("toQueryManageMeeting");
    },
    watch: {
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  /* 播放 */

  .mp4-area
    min-width: 600px
    min-height: 300px
    height: 336px
    position: fixed
    left:20%
    right:30%
    top:10%
    bottom:0
    z-index: 9999

  .mp4-head
    float: left
    width: 100%
    height: 26px
    line-height: 26px
    background: #40495c
    color: #fff
    font-size: 12px
    text-indent: 10px

  .mp4-head i
    float: right
    color: #fff
    font-style: normal
    font-weight: 900
    margin-right: 8px
    cursor: pointer

  .mp4-left
      height:-webkit-fill-available ;
      overflow: auto;
      float: left;
      width: 200px;
      min-height: calc(100% - 200px);
      background: #2e3542;

  .mp4-vedio
    float: left
    width: 320px

  .mp4-left ul
    margin-top: 20px

  .mp4-left ul li
    text-indent: 20px
    height: 30px
    line-height: 30px

  .mp4-left ul li a
    display: block
    padding-right: 10px
    text-indent: 20px
    color: #6e778a
    font-size: 12px

  .mp4-left ul li b
    font-weight: 400
    float: left
    width: 132px
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap
    cursor: pointer

  .mp4-left ul li a span
    float: right;

  .mp4-left ul li.play-now b
    color: #01abac;

  #close-mp4
    font-size: 10px;
    position: relative;
    top: 12px;



  #coor
    z-index: 20;
    width: 10px;
    height: 10px;
    overflow: hidden;
    cursor: se-resize;
    position: absolute;
    right: 0;
    bottom: 0;
/* background-color: #09C;     */

  .mp4-video
    height: 100%;
    width:calc(100%  - 200px);
    float:left;

  video
    object-fit: fill;
    width:100%;
    height:-webkit-fill-available;
    min-width: 400px;
    min-height: 300px;
  /* 拖动 */

  #drag {
    cursor: w-resize;
    width: 4px;
    position: absolute;
    top: 0;
    height: 100%;
    right: -4px;
    background: transparent;
  }
  .file-block
    min-height: 342px
  .querysearch
    margin-bottom: 15px
  .commonAddcourse
    height: 100%
  .addCourse
    height: 46px
    background: $color-background-d
    overflow hidden
    margin-bottom: -10px
  .manageTitle
    float: left
    line-height: 30px
    font-size: 18px
    color: #000
    margin-left: 20px
    width: auto
  .managesm
    float: left;
    line-height: 20px
    width: 40px
    height: 20px
    background: #ccc
    color: #fff
    text-align: center
    border-radius: 5px
    margin: 5px 0 0 5px
  .playback
    float: right
    margin: 5px 20px 0 0
    width: 90px
    text-align: center
    height: 30px
    line-height: 30px
    cursor: pointer
    border-radius: 4px
    background: #00abad
    color: #fff
    font-size: 14px
  .unplayback
    float: right
    margin: 5px 20px 0 0
    width: 90px
    text-align: center
    height: 30px
    line-height: 30px
    cursor: pointer
    border-radius: 4px
    background:#c9cbd1
    color: #fff
    font-size: 14px
  .course_top
    background: #fff
    overflow-y: auto
  .label_title
    display: block
    width: 110px
    line-height 24px
    text-align: right
    float: left
  .info_content
    display: block
    width: calc(100% - 120px)
    line-height 24px
    float: left
    color: #000
    em
      color $color-maingrey
      font-size: 12px
      font-style:normal
  .select-time input
    width:100%
  .setPassword
    width: 170px
    color: #606266
    margin: 0 15px
  .closeBtn
    width: 18px
    height: 18px
    display: inline-block
    font-size: 15px
    text-align: center
    line-height: 16px
    background: #d7d6d6
    border-radius: 50%
    margin-left: 3px
    color: $color-index-text
    cursor: pointer

  .tabs-content
    overflow: hidden
    background: $color-index-text


  .search
    background: $color-index-text
    margin-bottom: 16px
    padding: 15px 0

  ._member
    line-height: 26px !important
    border: 1px solid #dcdfe6

  .memberNull
    height: 26px
  .memberTrue
    height: 400px
    overflow-y: auto
    overflow-x: hidden
  .scient
    position: relative
    left: -8px

  .arrow_first
    position: relative;
    top: 12px;
    left: 130px;

  .rtHeight
    overflow-y: auto

  .overtHeight
    height: 100%

  .rightList
    margin: 5px 10px
    float: left

  .arrow_second
    position: relative
    top: 12px
    left: 250px

  .tabs-text
    position: relative
    // top: -20px
  .p-table-text
    margin-left:20px
  .radius_input
    min-width: 200px
    width: 70%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    position: absolute
    right: 20px
    top: -14px
    padding: 0 20px

  .rSearch
    position: relative
    margin-bottom: 10px

  .point
    position: absolute
    right: 20px
    top: 5px

  ._input
    min-width: 200px
    width: 100%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    right: 20px
    top: -14px
    padding: 0 20px
    box-sizing: border-box;

  .secPoint
    right: 10px

  ._inputTable
    top: 13px

  .btn-box
    text-align: center
    margin: 40px 0
    .save-hair, .saving, .save, .cancel
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
    .save
      background: $color-background-hover
      margin-right: 80px
    .commonBtn
      width: 90px
    .cancel
      background: $button-del
    .save-hair
      background: $button-base-color
      margin-right: 80px
    .saving
      background: $color-background-hover
</style>



// WEBPACK FOOTER //
// queryManageMeeting.vue?110dff6c